"use strict";
// generated-repayment-tape.d.ts
Object.defineProperty(exports, "__esModule", { value: true });
exports.artifactType = exports.IntermediateRecordConfigSchema = exports.nodeType = exports.UIConfigSchema = void 0;
const zod_1 = require("zod");
const tasks_1 = require("../../tasks");
exports.UIConfigSchema = zod_1.z.object({
    artifactSlug: zod_1.z.string().describe('Artifact slug'),
    loanProductSlug: zod_1.z.string().describe('Loan product slug'),
    creditFacilitySlug: zod_1.z.string().nullable().describe('Credit facility slug'),
    rawExternalReceivableIdField: zod_1.z
        .string()
        .describe('Specifies the field in the raw tape that identifies how to map to associated receivable'),
    rawRepaymentTapeArtifactSlug: zod_1.z
        .string()
        .describe('Raw repayment tape artifact slug'),
    generatedLoanTapeArtifactSlug: zod_1.z
        .string()
        .describe('Generated loan tape artifact slug'),
});
exports.nodeType = 'file_generatedRepaymentTape';
exports.IntermediateRecordConfigSchema = tasks_1.TapeBuilderTaskSchema.and(exports.UIConfigSchema.omit({
    artifactSlug: true,
    loanProductSlug: true,
    creditFacilitySlug: true,
}).extend({
    externalReceivableIdField: zod_1.z
        .string()
        .describe('Sanitized version of rawExternalReceivableIdField, easier to use with sanitized data'),
}));
exports.artifactType = 'generatedRepaymentTape';
//# sourceMappingURL=types.js.map